<section class="it-responsepane">
	<div class="it-resbar" *ngIf="vm.lastResponse">
		<div class="it-resbar-tabs">
			<button type="button" class="it-tab" [class.is-active]="vm.responseTab==='body'" (click)="setResponseTabLocal('body')">
				Preview
			</button>

			<button type="button" class="it-tab" [class.is-active]="vm.responseTab==='headers'" (click)="setResponseTabLocal('headers')">
				Headers
			</button>

			<button type="button" class="it-tab" [class.is-active]="vm.responseTab==='grid'" [disabled]="!canGrid()" (click)="setResponseTabLocal('grid')">
				Grid
			</button>

			<button class="it-toolbtn" type="button" (click)="onCopyClick()" [disabled]="!canCopy">
				{{ copied ? 'Copied' : 'Copy' }}
			</button>

			<button class="it-toolbtn danger" type="button" (click)="onClearCacheClick()" [disabled]="isClearingCache">
				{{ isClearingCache ? 'Cleared' : 'Clear cache' }}
			</button>
		</div>
	</div>

	<div class="it-resbody" *ngIf="!vm.lastResponse">
		<div class="it-empty">No response yet.</div>
	</div>

	<!-- Preview tab -->
	<ng-container *ngIf="vm.lastResponse && vm.responseTab==='body'">
		<div class="it-resfind" style="padding-top: 10px; padding-left: 9px;">
			<input #findInput class="it-toolinput it-findinput" type="text" placeholder="Find in response" [value]="findQuery" (input)="findChanged.emit($any($event.target).value)" (keydown)="onFindKeyDown($event)" />

			<div class="it-find-nav" role="group" aria-label="Find navigation">
				<button class="it-mini it-mini-seg left" type="button" (click)="onPrev()" [disabled]="!canFind()">Prev</button>
				<button class="it-mini it-mini-seg right" type="button" (click)="onNext()" [disabled]="!canFind()">Next</button>
			</div>

			<span class="it-toolmeta" [class.is-empty]="!findQuery">
				<ng-container *ngIf="renderedBodyHtml$ | async as f">
					{{
						(findQuery && findQuery.trim().length >= 2)
							? (f.matches ? (f.index + 1) + ' / ' + f.matches : '0 / 0')
							: ' '
					}}
				</ng-container>
			</span>

			<button class="it-mini it-mini-ghost danger" type="button" (click)="clearFind.emit()" [disabled]="!(findQuery || '').length">
				Clear
			</button>
		</div>

		<div class="it-resbody">
			<!-- HUGE MODE: virtual scroll, line numbers always (JSON/XML/TEXT) -->
			<ng-container *ngIf="isHuge; else normalNumbered">
				<cdk-virtual-scroll-viewport class="it-virt" [itemSize]="VIRT_LINE_HEIGHT" [minBufferPx]="VIRT_LINE_HEIGHT * 20" [maxBufferPx]="VIRT_LINE_HEIGHT * 60">

					<div class="it-virt-row" *cdkVirtualFor="let i of lineIndexArray; trackBy: trackByIndex">
						<div class="it-lnline">{{ i + 1 }}</div>
						<div class="it-line">{{ getLine(i) }}</div>
					</div>

				</cdk-virtual-scroll-viewport>
			</ng-container>

			<!-- NORMAL MODE: single numbered DOM for JSON/XML/TEXT -->
			<ng-template #normalNumbered>
				<div class="it-pre it-pre-dark it-pre-numbered">
					<div class="it-reswrap">
						<div class="it-ln" #respLn>
							<div class="it-lnline" *ngFor="let n of respLineNumbers">{{ n }}</div>
						</div>

						<div class="it-rescode" #respPretty [innerHTML]="(renderedBodyHtml$ | async)?.html | trustHtml" (scroll)="syncRespScroll()">
						</div>
					</div>
				</div>
			</ng-template>
		</div>
	</ng-container>

	<!-- Headers tab -->
	<div class="it-resbody" *ngIf="vm.lastResponse && vm.responseTab==='headers'">
		<pre class="it-pre it-pre-dark">{{ vm.lastResponse.headersText }}</pre>
	</div>

	<!-- Grid tab -->
	<div class="it-resbody" *ngIf="vm.lastResponse && vm.responseTab==='grid'">
		<div class="it-gridtools">
			<input class="it-toolinput it-gridpath" type="text" placeholder="Grid path (e.g. d.results)" [value]="vm.gridPath" (input)="gridPathChanged.emit($any($event.target).value)" />

			<button class="it-mini" type="button" (click)="togglePathPicker()">Pick</button>

			<span class="it-toolmeta" [class.is-empty]="!vm.gridPath">
				{{ vm.gridError ? vm.gridError : (vm.canShowGrid ? ((vm.gridRows?.length || 0) + ' rows') : ' ') }}
			</span>
		</div>

		<div class="it-pathpicker" *ngIf="isPathPickerOpen">
			<dx-tree-view [items]="pathTreeItems$ | async" displayExpr="text" keyExpr="id" selectionMode="single" (onItemClick)="onPathNodeClick($event)">
			</dx-tree-view>

			<div class="it-pathhint">
				Tip: click an array node to populate the grid. Arrays are marked with [ ].
			</div>
		</div>

		<dx-data-grid *ngIf="vm.gridRows" [dataSource]="vm.gridRows" [showBorders]="true" [columnMinWidth]="160" [allowColumnResizing]="true" columnResizingMode="widget">
			<dxo-filter-row [visible]="true"></dxo-filter-row>
			<dxo-search-panel [visible]="true"></dxo-search-panel>
			<dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
		</dx-data-grid>

		<div class="it-empty" *ngIf="!vm.gridRows">
			Enter a JSON path that resolves to an array (example: <code>d.results</code>).
		</div>
	</div>
</section>
